'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var SelfStandingLamp = function (_React$Component) {
    _inherits(SelfStandingLamp, _React$Component);

    function SelfStandingLamp() {
        _classCallCheck(this, SelfStandingLamp);

        return _possibleConstructorReturn(this, (SelfStandingLamp.__proto__ || Object.getPrototypeOf(SelfStandingLamp)).apply(this, arguments));
    }

    _createClass(SelfStandingLamp, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M20.588 11.321c0.37-0.466 0.368-0.914 0.3-1.207-0.003-0.017-0.008-0.033-0.013-0.050-0.654-2.012-3.34-9.367-3.454-9.678-0.085-0.232-0.305-0.386-0.552-0.386h-8.144c-0.247 0-0.467 0.154-0.552 0.386-0.114 0.312-2.8 7.666-3.454 9.678-0.005 0.016-0.009 0.032-0.014 0.050-0.068 0.294-0.070 0.742 0.301 1.207 1.031 1.296 4.357 1.818 7.159 1.89v15.418c-1.288 0.271-2.258 1.416-2.258 2.784 0 0.324 0.263 0.587 0.588 0.587h4.517c0.324 0 0.588-0.263 0.588-0.587 0-1.368-0.97-2.513-2.258-2.784v-15.415c2.819-0.063 6.205-0.583 7.247-1.893zM5.925 10.589c-0.079-0.099-0.083-0.158-0.078-0.193 0.577-1.769 2.718-7.654 3.289-9.222h7.322c0.571 1.568 2.711 7.453 3.288 9.222 0.006 0.035 0.001 0.094-0.078 0.193-0.559 0.703-3.157 1.45-6.872 1.456-3.716-0.006-6.313-0.753-6.872-1.456zM14.316 30.825h-3.128c0.238-0.633 0.849-1.083 1.564-1.083s1.326 0.45 1.564 1.083z' })
            );
        }
    }]);

    return SelfStandingLamp;
}(_react2.default.Component);

SelfStandingLamp.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = SelfStandingLamp;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/self-standing-lamp.js
// module id = 1122
// module chunks = 0